module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Black_MockedUp.2c778dbc.jpg";